import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import Column from 'gatsby-theme-pagebuilder/src/components/column/index';
import CoreContent from 'gatsby-theme-core/src/components/content';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

const Item = styled.div`
  padding: 0.75rem 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  &:nth-child(odd) {
    border-right: 1px solid ${({ theme }) => theme.grayLightColor};
  }

  > * {
    border-bottom: 1px solid ${({ theme }) => theme.grayLightColor};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 1rem;
  }
  &:last-child > div {
    border-bottom: 0;
  }
  &:nth-last-child(2):nth-child(odd) > div {
    border-bottom: 0;
  }
`;

const Logos = ({
  // id,
  columnWidth,
  align,
  justify,
  // card,
  offset,
}) => (
  <Column
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    card
    offset={offset}
  >
    <CoreContent>
      <h2>Aangesloten bij</h2>
      <Grid>
        <Item>
          <div>
            <StaticImage alt="bovag" src="./bovag.png" width={104} />
          </div>
        </Item>
        <Item>
          <div>
            <StaticImage alt="duurzaam repareren" src="./duurzaam-repareren.png" width={124} />
          </div>
        </Item>
        <Item>
          <a href="https://www.jamesautoservice.nl/vestigingen/gerrit-boks-apeldoorn/">
            <StaticImage alt="James auto service" src="./james.png" width={132} />
          </a>
        </Item>
        <Item>
          <div>
            <StaticImage alt="erkend duurzaam" src="./erkend-duurzaam.png" width={76} />
          </div>
        </Item>
        <Item>
          <div>
            <StaticImage alt="RDC" src="./rdc.png" width={114} />
          </div>
        </Item>
        <Item>
          <div>
            <StaticImage alt="RDW" src="./rdw.png" width={128} />
          </div>
        </Item>
      </Grid>
    </CoreContent>
  </Column>
);

export default Logos;
